import { useAtomValue } from 'jotai';
import { pageNameAtom } from '../../atoms';

export const useCurrentPageName = () => {
    const pageName = useAtomValue(pageNameAtom);
    return pageName;
};
